import React from 'react';
import {
  Position,
  PureComponent,
  PuzzleButton,
  Container,
  PuzzleToggle, VBox
} from 'puzzle';
import StatusSection from "./StatusSection";
import _ from 'lodash';
import { BATCH_OR_LANGUAGE, STATUS_DATA, STATUS_PROPS, STATUS_STATE } from "./Types";
import PoliciesManager from "../../../util/Policies";
import classNames from "classnames";

class SubmissionStatus extends PureComponent<STATUS_PROPS, STATUS_STATE> {

  state = {
    activeTab: 'languages',
    submissionStatusData: [],
    disableDownloadDeliverable: false
  };
  static defaultProps = {
    submissionData: {}
  };

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    super.moduleDidMount();
    this.loadTabData();
  };

  /**
   * Get new submission status only when selection changes
   */
  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    const { submissionData } = this.props;
    const { submissionId, projectId } = submissionData;

    const selectionChanged: boolean = prevProps.submissionData.submissionId !== submissionId;
    if (selectionChanged) {
      this.dispatch('getSubmissionStatus', Position.end, { submissionId, projectId });
    }
  }

  /**
   * Get either all batches or all languages depending on the selected tab
   */
  getLevelData = (level: BATCH_OR_LANGUAGE): string[] => {
    let statusData: STATUS_DATA[] = this.state.submissionStatusData;
    let allData: string[] = statusData.reduce(this.statusDataReducer.bind(this, level), []).sort();
    return allData;
  };

  /**
   * Generate heading and subheading depending on the tab selection
   */
  generateStatusData = (): any[] => {
    const { activeTab } = this.state;
    let level: BATCH_OR_LANGUAGE = 'batchName';
    let subLevel: BATCH_OR_LANGUAGE = 'targetLanguage.value';

    if (activeTab === 'languages') {
      level = 'targetLanguage.value';
      subLevel = 'batchName';
    }
    const levelData: string[] = this.getLevelData(level);
    const data = levelData.map(this.mapLevelData.bind(this, level, subLevel));

    return data;
  };

  /**
   * Dispatcher action that retrieves submission status data
   */
  loadSubmissionStatus = ((response: any, disableDownloadDeliverable: boolean) => {
    this.setState({ submissionStatusData: response, disableDownloadDeliverable });
  });

  /**
   * Requests tab data form server
   */
  loadTabData = () => {
    const { submissionData } = this.props;
    const { submissionId, projectId } = submissionData;
    this.dispatch('getSubmissionStatus', Position.start, { submissionId, projectId });
  };

  /**
   * Return sub sections for current section
   */
  mapLevelData = (level: BATCH_OR_LANGUAGE, subLevel: BATCH_OR_LANGUAGE, sectionName: string) => {
    const { submissionStatusData } = this.state;
    let subSections: STATUS_DATA[] = submissionStatusData.filter((item: STATUS_DATA) => _.get(item, level) === sectionName);
    subSections = subSections.map((item: STATUS_DATA) => ({ ...item, subSectionName: _.get(item, subLevel) }));
    subSections = _.sortBy(subSections, 'subSectionName');
    return {
      sectionName,
      subSections
    }
  };

  /**
   * Set currently active tab e.g. batches/languages
   */
  setActiveTab = ((tab: string) => {
    this.setState({ activeTab: tab });
  });

  /**
   * Return all unique batches/languages
   */
  statusDataReducer = (level: BATCH_OR_LANGUAGE, data: string[], job: any): string[] => {
    const sectionName: string = _.get(job, level);
    if (!data.includes(sectionName)) {
      data = [...data, sectionName];
    }
    return data;
  };

  /**
   * Starts download of all deliverable files on submission
   */
  downloadDeliverables = () => {
    this.dispatch('submissionStatusGetDeliverableFiles', '', {
      params: {
        downloadAllDeliverables: true
      }
    })
  };

  render() {
    const { submissionData } = this.props;
    const { projectId } = submissionData;
    const { submissionStatusData, disableDownloadDeliverable, activeTab } = this.state;
    let statusData = _.isEmpty(submissionStatusData) ? [] : this.generateStatusData();
    const statusContentCls = classNames(
      'tp-submission-status-content'
    );

    return (
      <>
        <Container
          vBox
          className="tp-drawer-body-tab-status-content"
        >
          <Container
            alignItemsCenter
            hBox
            justifyContentBetween
            wrap
            className={'tp-drawer-body-tab-status-header'}
          >
            <PuzzleToggle
              cssClass={'k-justify-content-start'}
              id={this.moduleName}
              switcherLabel={this.translate('switcherLabel')}
              checked={activeTab === 'batches'}
              activeTab={activeTab}
              setActiveTab={this.setActiveTab}
              switcherOptions={[{
                name: 'languages',
                locale: this.translate('languages')
              }, {
                name: 'batches',
                locale: this.translate('batches')
              }]}
            />
            {PoliciesManager.inProject(projectId)?.hasDownloadDeliverablePolicy &&
              <PuzzleButton
                className={"tp-download-btn"}
                iconClass={'tp-icon tp-download'}
                reverse
                fillMode={'flat'}
                disabled={disableDownloadDeliverable}
                themeColor={'primary'}
                onClick={this.downloadDeliverables}
              >
                {this.translate('downloadDeliverables')}
              </PuzzleButton>
            }
          </Container>
          <VBox
            gap={1}
            className={statusContentCls}
          >
            <StatusSection
              data={statusData}
              submissionData={submissionData}
              submissionStatus={this.props.submissionStatus}
              downloadDeliverables={this.downloadDeliverables}
            />
          </VBox>
        </Container>
      </>
    );
  }
}

export default SubmissionStatus;
